import React from 'react';
import { Form, Select, Image } from 'antd';
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg"
import "./CustomSelect.scss"

const { Option } = Select;

const CustomSelect = ({ label, name, rules, isRequired = false, options, placeholder, showSearch, ...rest }) => {
    return (
        <Form.Item
            label={
                <span>
                    {label}
                    {isRequired && (
                        <span style={{ color: "red", marginLeft: 4 }}>*</span>
                    )}
                </span>
            }
            name={name}
            rules={rules}
            className="custom-select"
        >
            <Select
                placeholder={placeholder}
                showSearch={showSearch}
                suffixIcon={<Image src={ArrowDownIcon} alt='Arrow Down' preview={false} />}
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                }
                {...rest}
            >
                {options?.map(option => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
};

export default CustomSelect;
